import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function OpenExternallyIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M20.71 3.295a.995.995 0 0 1 .29.702V10a1 1 0 1 1-2 0V6.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L17.586 5H14a1 1 0 1 1 0-2h6a1 1 0 0 1 .705.29l.004.005ZM8 4a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-2a1 1 0 1 0-2 0v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2a1 1 0 1 0 0-2H8Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
